import { Actor, Color, Vector, Polygon } from 'excalibur';

export class Mountain extends Actor {
    constructor(centerX: number, baseY: number, width: number, height: number) {
        super({ x: centerX, y: baseY - height / 2 });
        const points = Mountain.generateMountainPoints(centerX, baseY, width, height);
        this.graphics.use(new Polygon({ points, color: Color.Green }));
    }

    // Make the mountain more pointy and span from near the bottom to near the top
    static generateMountainPoints(centerX: number, baseY: number, width: number, height: number): Vector[] {
        const points: Vector[] = [];
        const left = centerX - width / 2;
        const right = centerX + width / 2;
        const segments = 16;
        const topY = 260; // leave more space at the top
        const bottomY = baseY;
        // Inverted parabola for a peak in the middle
        for (let i = 0; i <= segments; i++) {
            const t = i / segments;
            const x = left + t * width;
            // Inverted parabola: max at t=0.5, min at t=0,1
            const peak = bottomY - (bottomY - topY) * (1 - 4 * (t - 0.5) * (t - 0.5));
            const noise = Math.random() * 40 - 20;
            const y = peak + noise;
            points.push(new Vector(x, y));
        }
        // Close the polygon at the bottom
        points.push(new Vector(right, bottomY));
        points.push(new Vector(left, bottomY));
        return points;
    }
}
